import * as actions from 'actions';

const INITIAL_STATE = {
  isFetching: false,
  isSubmitting: false,
  initialAvatarId: null,
  selectedAvatarId: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case actions.AUTH_UPDATE: {
      const currentUserAvatarId = action.authData.user.avatar.id;
      return {
        ...state,
        selectedAvatarId: currentUserAvatarId,
        initialAvatarId: currentUserAvatarId
      };
    }

    case actions.USER_UPDATE_SUCCESS: {
      const avatarChanged = action.updates.avatar !== undefined;
      const currentUserAvatarId = avatarChanged ? action.updates.avatar : state.initialAvatarId;
      return {
        ...state,
        isSubmitting: false,
        initialAvatarId: currentUserAvatarId,
        selectedAvatarId: currentUserAvatarId
      };
    }

    case actions.USER_AVATARS_FETCH: {
      return {
        ...state,
        isFetching: true
      };
    }

    case actions.USER_AVATARS_FETCH_SUCCESS: {
      const initialAvatarId = state.initialAvatarId;
      return {
        ...state,
        isFetching: false,
        selectedAvatarId: initialAvatarId
      };
    }
    case actions.USER_AVATARS_FETCH_ERROR: {
      return {
        ...state,
        isFetching: false
      };
    }

    case actions.USER_AVATARS_CHANGE_ACTIVE: {
      return {
        ...state,
        selectedAvatarId: action.avatarId
      };
    }

    case actions.USER_UPDATE: {
      return {
        ...state,
        isSubmitting: true
      };
    }

    case actions.USER_UPDATE_ERROR: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/members/state/user/avatarSelection/reducer.js
 **/